export const states = [
    {
      "abbreviation": "35",
      "stateValueFromApi": "Andaman & Nicobar",
      "name": "Andaman and Nicobar Islands"
    },
    {
      "abbreviation": "37",
      "stateValueFromApi": "Andhra Pradesh",
      "name": "Andhra Pradesh"
    },
    {
      "abbreviation": "12",
      "stateValueFromApi": "Arunachal Pradesh",
      "name": "Arunachal Pradesh"
    },
    {
      "abbreviation": "18",
      "stateValueFromApi": "Assam",
      "name": "Assam"
    },
    {
      "abbreviation": "10",
      "stateValueFromApi": "Bihar",
      "name": "Bihar"
    },
    {
      "abbreviation": "4",
      "stateValueFromApi": "Chandigarh",
      "name": "Chandigarh"
    },
    {
      "abbreviation": "22",
      "stateValueFromApi": "Chattisgarh",
      "name": "Chattisgarh"
    },
    {
      "abbreviation": "25",
      "stateValueFromApi": "Dadra & Nagar Haveli",
      "name": "Dadra and Nagar Haveli"
    },
    {
      "abbreviation": "DD",
      "stateValueFromApi": "Daman & Diu",
      "name": "Daman and Diu"
    },
    {
      "abbreviation": "7",
      "stateValueFromApi": "Delhi",
      "name": "Delhi"
    },
    {
      "abbreviation": "30",
      "stateValueFromApi": "Goa",
      "name": "Goa"
    },
    {
      "abbreviation": "24",
      "stateValueFromApi": "Gujarat",
      "name": "Gujarat"
    },
    {
      "abbreviation": "6",
      "stateValueFromApi": "Haryana",
      "name": "Haryana"
    },
    {
      "abbreviation": "2",
      "stateValueFromApi": "Himachal Pradesh",
      "name": "Himachal Pradesh"
    },
    {
      "abbreviation": "1",
      "stateValueFromApi": "Jammu & Kashmir",
      "name": "Jammu and Kashmir"
    },
    {
      "abbreviation": "20",
      "stateValueFromApi": "Jharkhand",
      "name": "Jharkhand"
    },
    {
      "abbreviation": "29",
      "stateValueFromApi": "Karnataka",
      "name": "Karnataka"
    },
    {
      "abbreviation": "32",
      "stateValueFromApi": "Kerala",
      "name": "Kerala"
    },
    {
      "abbreviation": "31",
      "stateValueFromApi": "Lakshadweep",
      "name": "Lakshadweep"
    },
    {
      "abbreviation": "23",
      "stateValueFromApi": "Madhya Pradesh",
      "name": "Madhya Pradesh"
    },
    {
      "abbreviation": "27",
      "stateValueFromApi": "Maharashtra",
      "name": "Maharashtra"
    },
    {
      "abbreviation": "14",
      "stateValueFromApi": "Manipur",
      "name": "Manipur"
    },
    {
      "abbreviation": "17",
      "stateValueFromApi": "Meghalaya",
      "name": "Meghalaya"
    },
    {
      "abbreviation": "15",
      "stateValueFromApi": "Mizoram",
      "name": "Mizoram"
    },
    {
      "abbreviation": "13",
      "stateValueFromApi": "Nagaland",
      "name": "Nagaland"
    },
    {
      "abbreviation": "21",
      "stateValueFromApi": "Odisha",
      "name": "Odisha"
    },
    {
      "abbreviation": "34",
      "stateValueFromApi": "Pondicherry",
      "name": "Puducherry"
    },
    {
      "abbreviation": "3",
      "stateValueFromApi": "Punjab",
      "name": "Punjab"
    },
    {
      "abbreviation": "8",
      "stateValueFromApi": "Rajasthan",
      "name": "Rajasthan"
    },
    {
      "abbreviation": "11",
      "stateValueFromApi": "Sikkim",
      "name": "Sikkim"
    },
    {
      "abbreviation": "33",
      "stateValueFromApi": "Tamil Nadu",
      "name": "Tamil Nadu"
    },
    {
      "abbreviation": "36",
      "stateValueFromApi": "Telangana",
      "name": "Telangana"
    },
    {
      "abbreviation": "16",
      "stateValueFromApi": "Tripura",
      "name": "Tripura"
    },
    {
      "abbreviation": "9",
      "stateValueFromApi": "Uttar Pradesh",
      "name": "Uttar Pradesh"
    },
    {
      "abbreviation": "5",
      "stateValueFromApi": "Uttarakhand",
      "name": "Uttarakhand"
    },
    {
      "abbreviation": "19",
      "stateValueFromApi": "West Bengal",
      "name": "West Bengal"
    }
  ]